import Homepage from "./components/Homepage/Homepage";
import Ispirazione from "./components/Ispirazione";
import Realizzazione from "./components/Realizzazione";
import Svolta from "./components/Svolta";
import ColoriFormati from "./components/ColoriFormati";
import Decorazioni from "./components/Decorazioni";
import Dettagli from "./components/Dettagli";
import Caratteristiche from "./components/Caratteristiche";
import Collezione from "./components/Collezione";
import FormPage from "./components/FormPage";
import Footer from "./components/Footer";
import "./globalStyles.css";
import { Provider } from "react-redux";
import { store } from "../src/components/app/store";
import EfficientCursor from "react-efficient-cursor";
import cursorWrap from "./components/assets/cursor/cursorWrapper.svg";
import cursorPoint from "./components/assets/cursor/cursorPoint.svg";
import React from "react";

function App() {
  const [onSlider, setSlider] = React.useState(false);
  return (
    <div className="App">
      <Provider store={store}>
        <CursorComponent onSlider={onSlider} />
        <Homepage />
        <Ispirazione setSlider={setSlider} />
        <Realizzazione />
        <Svolta />
        <ColoriFormati />
        <Decorazioni />
        <Dettagli />
        <Caratteristiche />
        <Collezione />
        <FormPage />
        <Footer />
      </Provider>
    </div>
  );
}

const CursorComponent = ({ onSlider }) => {
  return onSlider ? null : (
    <>
      <EfficientCursor speed={0.8} style={{ cursor: "none" }}>
        <img className="cursor" src={cursorPoint} alt="cursor" />
      </EfficientCursor>
      <EfficientCursor speed={0.8}>
        <img className="cursor" src={cursorWrap} alt="cursor" />
      </EfficientCursor>
    </>
  );
};

export default App;